import React from 'react';
import PaintCommercialConfigWorkspace from '../../placeholders/PaintCommercialConfigWorkspace';

const AdditiveCommercialConfigWorkspace = ({ isDarkMode = false }) => (
  <PaintCommercialConfigWorkspace
    isDarkMode={isDarkMode}
    groupKeys={['leads', 'prospecting']}
    title="Ajustes Comercial · Aditivos"
    subtitle="Segmentos, canales, industrias y etapas de funnel usados en Leads y Prospección de Aditivos."
  />
);

export default AdditiveCommercialConfigWorkspace;
